import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';
import { IUser } from '../../../resource/user/user.types';
import * as constants from './reports.constants';
import {
  IClearMeetingReport,
  IClearUserReports,
  IFetchMeetingReportsAction,
  IFetchUserReportsAction,
  IMeetingReport,
  IMeetingReportsSearchParams,
  IStoreMeetingReport,
  IUserReport,
} from './reports.types';

export const fetchMeetingReports = (
  meetingId: IMeetingSimple['id'],
  queryParams?: IMeetingReportsSearchParams,
): IFetchMeetingReportsAction => ({
  type: constants.FETCH_MEETING_REPORTS,
  payload: { meetingId, queryParams },
});

export const fetchUserReports = (userId: IUser['id']): IFetchUserReportsAction => ({
  type: constants.FETCH_USER_REPORTS,
  payload: { userId },
});

export const storeUserReports = (userReports: IUserReport) => ({
  type: constants.STORE_USER_REPORTS,
  payload: userReports,
});

export const clearUserReports = (): IClearUserReports => ({
  type: constants.CLEAR_USER_REPORTS,
});

export const storeMeetingReport = (meetingReports: IMeetingReport): IStoreMeetingReport => ({
  type: constants.STORE_MEETING_REPORTS,
  payload: meetingReports,
});

export const clearMeetingReports = (): IClearMeetingReport => ({
  type: constants.CLEAR_MEETING_REPORTS,
});
